import { get } from "./index";

export const getAllVideoGallery = (params) => {
  const request = {
    subUrl: `/website/getCategoryViseVideoGallery`,
    params,
  };
  return get(request);
};
